<div [formGroup]="form">
    <div class="row">
        <div class="apc-form-card">
            <span class="title">{{'person.extras.metadata' | translate}}</span>
            <div class="container-fluid my-2">
                <div class="row">
                    <div class="form-group col-lg-6">
                        <apc-form-select formControlName="extraTypeIdentifier" [items]="typesDropdown"
                            optionValue="identifier" [renderValue]="findDropdownRenderValue()" [isRequired]="true">
                            <label label>{{'person.extras.typology' | translate}}</label>
                        </apc-form-select>
                    </div>

                    <div class="form-group col-lg-12 mt-5">
                        <apc-form-input [class]="'form-control'" formControlName="value" [type]="'textarea'"
                            [rows]="'4'" [isRequired]="true">
                            <label label>{{'person.extras.content' | translate}}</label>
                        </apc-form-input>
                    </div>
                </div>
            </div>
        </div>
    </div>